import { Component, Input, OnInit } from '@angular/core';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { Base } from '@app/models/base';
import { sanitizeTextInput } from '@app/utils/text-sanitize.util';

@Component({
    selector: 'app-mat-form-field',
    templateUrl: './mat-form-field.component.html',
    styleUrls: ['./mat-form-field.component.scss'],
    standalone: false
})
export class MatFormFieldComponent implements OnInit {

  @Input() model: Base.IBase;
  @Input() property: keyof MatFormFieldComponent['model'];
  @Input() label: string;
  @Input() hint: string;
  @Input() disabled: boolean = false;
  @Input() inputName: string;
  @Input() placeholder: string;
  @Input() type: string = 'text';
  @Input() min: string = '0';
  @Input() max: string = null;
  @Input() hideCleanButton: boolean = false;
  @Input() appearance: MatFormFieldAppearance = 'outline';
  @Input() maxRows: number = 5;
  @Input() minRows: number = 1;


  show: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Normalizes invisible/lookalike characters (see `sanitizeTextInput`) before
   * running validation, so text copy-pasted from PDFs/invoices doesn't fail
   * validators with confusing "invalid characters" errors.
   */
  onChange(): void {
    const value = this.model[this.property];
    if (typeof value === 'string') {
      const sanitized = sanitizeTextInput(value);
      if (sanitized !== value) {
        (this.model as any)[this.property] = sanitized;
      }
    }
    this.model.isValid();
  }

}


